<template>
  <div>
    <popup-view v-if="shows('CatalogPage', 'ProductOptions')" :resize="true" :isVisible="product.currentProduct !== null" @close="setCurrentProduct(null)">
      <edit-product-dialog self-fetch/>
    </popup-view>

    <popup-view v-if="shows('CatalogPage', 'ProductOptions')" :resize="true" :isVisible="productGroup.isAddingGroup" @close="setIsAddingGroup(false)">
      <edit-product-group-dialog self-fetch/>
    </popup-view>

    <popup-view v-if="shows('ProductOptions')" :isVisible="productOption.isAddingOptionList" @close="setIsAddingOptionList(false)">
      <add-option-list-dialog v-if="productOption.isAddingOptionList" @close="setIsAddingOptionList(false)" @created="setIsAddingOptionList(false)"/>
    </popup-view>

    <popup-view v-if="shows('UsersPage')" :isVisible="user.isAddingUser" @close="setAddingUser(false)">
      <edit-user-dialog v-if="user.isAddingUser" self-fetch/>
    </popup-view>

    <popup-view v-if="shows('TablesPage')" :isVisible="table.currentTable !== null" @close="setCurrentTable(null)">
      <edit-table-dialog self-fetch/>
    </popup-view>

    <popup-view v-if="shows('TablesPage')" :isVisible="table.currentZone !== null" @close="setCurrentZone(null)">
      <edit-zone-dialog/>
    </popup-view>

    <popup-view v-if="shows('TablesPage')" :isVisible="table.currentType !== null" @close="setCurrentType(null)">
      <edit-type-dialog/>
    </popup-view>

    <popup-view v-if="shows('Printers', 'UsersPage')" :isVisible="printer.currentPrinter !== null" @close="setCurrentPrinter(null)">
      <edit-printer-dialog/>
    </popup-view>

    <popup-view v-if="shows('Promo')" :isVisible="promo.isAddingPromo" @close="setIsAddingPromo(false)">
      <edit-promo-dialog self-fetch/>
    </popup-view>

    <popup-view v-if="shows('Vouchers')" :isVisible="voucher.isCreatingVouchers" @close="setIsCreatingVouchers(false)">
      <create-voucher-dialog v-if="voucher.isCreatingVouchers" self-fetch @close="setIsCreatingVouchers(false)"/>
    </popup-view>

    <popup-view v-if="shows('Pickup')" :isVisible="pickup.isAddingPickup" @close="setIsAddingPickup(false)">
      <edit-pickup-dialog/>
    </popup-view>

    <popup-view v-if="shows('clients')" :isVisible="client.isAddingClient" @close="setIsAddingClient(false)">
      <edit-client-dialog @cancel="setIsAddingClient(false)"/>
    </popup-view>

    <popup-view v-if="shows('ExtIntegration', 'UsersPage')" :isVisible="integration.isAddingIntegration" @close="setIsAddingIntegration(false)">
      <edit-integration-dialog self-fetch/>
    </popup-view>

    <popup-view v-if="shows('Kitchen')" :isVisible="kitchen.isAddingKitchen" @close="setIsAddingKitchen(false)">
      <edit-message-dialog @close="setIsAddingKitchen(false)"/>
    </popup-view>

    <popup-view v-if="shows('Media')" :isVisible="images.isAddingImage" @close="setIsAddingImage(false)">
      <add-image-dialog/>
    </popup-view>

    <popup-view v-if="shows('Icons')" :isVisible="icons.isAddingIcon" @close="setIsAddingIcon(false)">
      <add-icon-dialog @close="setIsAddingIcon(false)"/>
    </popup-view>

    <popup-view v-if="shows('create-org')" :resize="true" :isVisible="organisation.isCreatingOrg" @close="setIsCreatingOrg(false)">
      <create-org-dialog @close="setIsCreatingOrg(false)"/>
    </popup-view>

    <popup-view v-if="shows('SuperUsersPage')" :isVisible="superUser.isAddingSuperUser" @close="setAddingSuperUser(false)">
      <super-user-edit-dialog v-if="superUser.isAddingSuperUser"/>
    </popup-view>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import PopupView from "@/views/components/PopupView.vue";
import {lazyComponent} from "@/helpers/lazyLoad";
const EditProductDialog = lazyComponent(() => import("@/views/dialogs/EditProductDialog.vue"));
const EditProductGroupDialog = lazyComponent(() => import("@/views/dialogs/EditProductGroupDialog.vue"));
const AddOptionListDialog = lazyComponent(() => import("@/views/dialogs/AddOptionListDialog.vue"));
const EditUserDialog = lazyComponent(() => import("@/views/dialogs/EditUserDialog.vue"));
const EditTableDialog = lazyComponent(() => import("@/views/dialogs/EditTableDialog.vue"));
const EditZoneDialog = lazyComponent(() => import("@/views/dialogs/EditZoneDialog.vue"));
const EditTypeDialog = lazyComponent(() => import("@/views/dialogs/EditTypeDialog.vue"));
const EditPrinterDialog = lazyComponent(() => import("@/views/dialogs/EditPrinterDialog.vue"));
const EditPromoDialog = lazyComponent(() => import("@/views/dialogs/EditPromoDialog.vue"));
const CreateVoucherDialog = lazyComponent(() => import("@/views/dialogs/CreateVoucherDialog.vue"));
const EditPickupDialog = lazyComponent(() => import("@/views/dialogs/EditPickupDialog.vue"));
const EditClientDialog = lazyComponent(() => import("@/views/dialogs/EditClientDialog.vue"));
const EditIntegrationDialog = lazyComponent(() => import("@/views/dialogs/EditIntegrationDialog.vue"));
const EditMessageDialog = lazyComponent(() => import("@/views/dialogs/EditMessageDialog.vue"));
const AddImageDialog = lazyComponent(() => import("@/views/dialogs/AddImageDialog.vue"));
const AddIconDialog = lazyComponent(() => import("@/views/dialogs/AddIconDialog.vue"));
const SuperUserEditDialog = lazyComponent(() => import("@/views/dialogs/SuperUserEditDialog.vue"));
const CreateOrgDialog = lazyComponent(() => import("@/views/dialogs/CreateOrgDialog.vue"));

export default {
  name: "QuickActionHost",
  components: {
    PopupView,
    EditProductDialog,
    EditProductGroupDialog,
    AddOptionListDialog,
    EditUserDialog,
    EditTableDialog,
    EditZoneDialog,
    EditTypeDialog,
    EditPrinterDialog,
    EditPromoDialog,
    CreateVoucherDialog,
    EditPickupDialog,
    EditClientDialog,
    EditIntegrationDialog,
    EditMessageDialog,
    AddImageDialog,
    AddIconDialog,
    SuperUserEditDialog,
    CreateOrgDialog
  },
  computed: {
    ...mapState({
      product: "product",
      productGroup: "productGroup",
      productOption: "productOption",
      user: "user",
      table: "table",
      printer: "printer",
      promo: "promo",
      voucher: "voucher",
      pickup: "pickup",
      client: "client",
      integration: "integration",
      kitchen: "kitchen",
      images: "images",
      icons: "icons",
      superUser: "superUser",
      organisation: "organisation"
    })
  },
  methods: {
    ...mapMutations("product", ["setCurrentProduct"]),
    ...mapMutations("productGroup", ["setIsAddingGroup"]),
    ...mapMutations("productOption", ["setIsAddingOptionList"]),
    ...mapMutations("user", ["setAddingUser"]),
    ...mapMutations("table", ["setCurrentTable", "setCurrentZone", "setCurrentType"]),
    ...mapMutations("printer", ["setCurrentPrinter"]),
    ...mapMutations("promo", ["setIsAddingPromo"]),
    ...mapMutations("voucher", ["setIsCreatingVouchers"]),
    ...mapMutations("pickup", ["setIsAddingPickup"]),
    ...mapMutations("client", ["setIsAddingClient"]),
    ...mapMutations("integration", ["setIsAddingIntegration"]),
    ...mapMutations("kitchen", ["setIsAddingKitchen"]),
    ...mapMutations("images", ["setIsAddingImage"]),
    ...mapMutations("icons", ["setIsAddingIcon"]),
    ...mapMutations("superUser", ["setAddingSuperUser"]),
    ...mapMutations("organisation", ["setIsCreatingOrg"]),
    shows(...routeNames) {
      return !routeNames.includes(this.$route.name);
    }
  }
};
</script>
